import { useEffect, useState } from "react";
import AuthFlowFrame from "../../components/AuthFlowFrame";
import SidePanel from "../../components/SidePanel";
import optOutField from "../../assets/images/opt_out_field.png";
import optOutToggle from "../../assets/images/opt_out_toggle.png";
import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Text } from "@jobber/components/Text";
import { Typography } from "@jobber/components/Typography";

function Step1() {
    const [jobberMarketplaceUrl, setJobberMarketplaceUrl] = useState("https://secure.getjobber.com/home");

    useEffect(() => {
        (async () => {
            const state = sessionStorage.getItem('state');
            // const response = await getJobberMarketplaceUrl(state);
            // if (response.data) {
            //     setJobberMarketplaceUrl(response.data);
            // }
        })();
    }, []);

    return (
        <AuthFlowFrame
            pretitle={""}
            title={"Your Jobber account is now connected to Listen360!"}
            sidePanel={
                <SidePanel>
                    <Heading level={2}>
                        <Typography emphasisType={"highlight"}>Opt a Client out of Syncing to Listen360</Typography>
                    </Heading>
                    <Text size={"base"}>
                       <ol>
                           <li>Navigate to the Client record in Jobber.</li>
                           <li>Under <b>Contact Info</b>, find the <b>Listen360 Integration</b> custom field box to see whether the Client has been opted out from syncing.</li>
                           <img
                               src={optOutField}
                               alt="Listen360 Integration custom field box in Jobber client Contact Info"
                               style={{ width: "100%", borderRadius: "4px", margin: "8px 0" }}
                           />
                           <li>To change this status, click the <b>Edit</b> button in the top right of the Client page.</li>
                           <li>In the <b>Primary contact details</b> section, expand the <b>Additional client details</b> panel and find the corresponding <b>Listen360 Integration</b> custom field box.</li>
                           <li>Toggle "Opt out of Listen360 sync" to <b>Yes</b>.</li>
                           <img
                               src={optOutToggle}
                               alt="Opt out of Listen360 Sync toggle in Jobber client details"
                               style={{ width: "100%", borderRadius: "4px", margin: "8px 0" }}
                           />
                           <li>Click the <b>Update Client</b> button at the bottom of the screen.</li>
                       </ol>
                    </Text>
                </SidePanel>
            }
            sidePanelContained={true}
            step={1}
            totalSteps={1}
            button={{
                link: jobberMarketplaceUrl,
                text: "Return to Jobber",
                type: "primary",
                disabled: false,
                loading: false,
            }}
        >
            <Content type={"div"} spacing={"base"}>
                <Text size={"large"}>
                    Your Integration Admin still needs to approve your account before jobs begin syncing to Listen360, but you can begin configuring your Clients right away.
                </Text>
                <Text size={"large"}>
                    By default, all jobs will sync to Listen360, but you can opt out any Client's jobs by toggling their "Sync to Listen360" field to <strong>NO</strong>. If you ever choose to opt out a Client whose previous jobs have already synced to Listen360, we'll send an email to let you know.
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step1;
